// Mirrors AppointmentConfirmationNew.Models.MedicalRecordPageStatus
export const PageStatus = {
    RequiresVerification: 1,
    Ready: 2,
    Expired: 3,
    NotFound: 4
}

// Mirrors Objects.EnumMedicalRecordOtpResult - CAL4 sends these as numbers.
export const OtpResult = {
    Success: 0,
    LinkNotFound: 1,
    LinkExpired: 2,
    InvalidGovId: 3,
    IdentificationFailed: 4,
    Blocked: 5,
    TooManyRequests: 6,
    CodeExpired: 7,
    InvalidCode: 8,
    SendFailed: 9,
    Failed: 10
}

// Mirrors Objects.EnumMedicalRecordOtpChannel
export const Channel = {
    Sms: 1,
    Email: 2
}

export const notices = {
    expired: {
        title: 'תוקף הקישור לרשומה הרפואית הסתיים',
        message: 'יש לפנות לגורם ששלח את הרשומה לקבלת קישור חדש.'
    },
    deadLink: {
        title: 'הקישור לרשומה הרפואית אינו תקין',
        message: 'יש לפנות לגורם ששלח את הרשומה.'
    },
    blocked: {
        title: 'הכניסה לרשומה הרפואית נחסמה',
        message: 'בוצעו יותר מדי ניסיונות זיהוי. יש לפנות לגורם ששלח את הרשומה לקבלת קישור חדש.'
    }
}

// A rate-limited call can come back with no body at all, so the http status is the fallback.
const resultByHttpStatus = {
    403: OtpResult.Blocked,
    404: OtpResult.LinkNotFound,
    429: OtpResult.TooManyRequests,
    502: OtpResult.SendFailed
}

export const getResult = (data, httpStatus) => {
    if (typeof data?.result === 'number') {
        return data.result;
    }

    return resultByHttpStatus[httpStatus] ?? OtpResult.Failed;
}

export const otpErrorText = (result) => {
    switch (result) {
        case OtpResult.InvalidGovId:
            return 'מספר ת"ז לא תקין';
        case OtpResult.IdentificationFailed:
            return 'מספר הת"ז אינו תואם לרשומה זו';
        case OtpResult.InvalidCode:
            return 'הקוד שהוזן שגוי';
        case OtpResult.CodeExpired:
            return 'תוקף הקוד הסתיים, יש לבקש קוד חדש';
        case OtpResult.TooManyRequests:
            return 'נשלחו יותר מדי קודים, יש להמתין לפני בקשת קוד נוסף';
        case OtpResult.SendFailed:
            return 'לא הצלחנו לשלוח את הקוד, יש לנסות שוב בעוד רגע';
        default:
            return 'אירעה שגיאה, יש לנסות שוב';
    }
}
